<script setup>
import ReturnCSV from '@/components/ReturnCSV.vue'

</script>
<template>
  <main>
    <div class="returns">
      <ReturnCSV />
    </div>
  </main>
</template>

<style>

</style>